import React from "react";
import "./../css/careers.scss";
import { Container, Row, Col } from "react-bootstrap";

const PrivacyPolicyPage = () => {
  return (
    <div>
      <Container>
        <div className="wrapBG">
          <Row className="wrapRowPrivacyPolicy">
            <Col xl="12" lg="12" md="12" sm="12">
              <h1 className="h1PrivacyPolicy">ПОВІДОМЛЕННЯ ПРО КОНФІДЕНЦІЙНІСТЬ</h1>
              <div className="wrapPrivacyPolicyBlock">
                <p className="pPrivacyPolicy">
                  Це повідомлення про конфіденційність визначає, як Sagax Software використовує та
                  захищає будь-яку інформацію, яку ви надаєте Sagax Software, коли ви
                  використовувати цей веб-сайт. Зверніть увагу, що інформація буде
                  процеси за межами ЄС/ЄЕЗ для виконання мети
                  збір та обробка персональних даних.
                </p>
                <p className="pPrivacyPolicy">
                  Sagax Software прагне забезпечити вашу конфіденційність
                  належним чином захищений. Чи повинні ми просити вас надати певні
                  інформація, за якою вас можна ідентифікувати під час використання цього
                  веб-сайті, тоді ви можете бути впевнені, що він використовуватиметься лише в
                  відповідно до цієї заяви про конфіденційність.
                </p>
                <p className="pPrivacyPolicy">
                  Sagax Software може час від часу змінювати це повідомлення
                  оновлення цієї сторінки. Ви повинні час від часу перевіряти цю сторінку
                  час, щоб переконатися, що ви задоволені будь-якими змінами. Це
                  повідомлення діє з 01.08.2023.
                </p>
                <h2 className="h2PrivacyPolicy">Що ми збираємо</h2>
                <p className="pPrivacyPolicy">
                  Ми можемо збирати таку інформацію:
                </p>
                <ul>
                  <li className="liPrivacyPolicy">Ім'я та посада;</li>
                  <li className="liPrivacyPolicy">
                    Контактна інформація, включаючи електронну адресу;
                  </li>
                  <li className="liPrivacyPolicy">
                    Демографічна інформація, така як поштовий індекс, уподобання та
                    інтереси;
                  </li>
                  <li className="liPrivacyPolicy">
                    Інша інформація, що стосується запитів клієнтів та/або
                    пропозиції.
                  </li>
                </ul>
                <h2 className="h2PrivacyPolicy">
                  Що ми робимо з інформацією, яку збираємо
                </h2>
                <p className="pPrivacyPolicy">
                  Надана інформація може бути додана до нашої CRM та інших
                  внутрішні системи для подальшої обробки. Інформація буде
                  зберігатимуться в наших внутрішніх системах, включаючи CRM, доки ви
                  подати запит на його видалення. Нам потрібна ця інформація
                  зрозуміти ваші потреби та надати вам кращий сервіс,
                  і, зокрема, з таких причин:
                </p>
                <ul>
                  <li className="liPrivacyPolicy">Внутрішнє діловодство;</li>
                  <li className="liPrivacyPolicy">
                    Ми можемо використовувати інформацію для покращення наших продуктів і
                    послуги;
                  </li>
                  <li className="liPrivacyPolicy">
                    Ми можемо періодично надсилати рекламні електронні листи про нові
                    проекти, спеціальні пропозиції чи іншу інформацію, яку ми вважаємо
                    Вам може бути цікаво використовувати адресу електронної пошти, яку ви
                    надали;
                  </li>
                  <li className="liPrivacyPolicy">
                    Час від часу ми також можемо використовувати вашу інформацію, щоб
                    зв’язатися з вами для вивчення ринку. Ми можемо зв'язатися з вами
                    електронною поштою, телефоном, факсом або поштою. Ми можемо використовувати інформацію для
                    налаштувати веб-сайт відповідно до ваших інтересів.
                  </li>
                </ul>
                <h2 className="h2PrivacyPolicy">Безпека</h2>
                <p className="pPrivacyPolicy">
                  Ми прагнемо забезпечити безпеку вашої інформації.
                  Щоб запобігти несанкціонованому доступу або розголошенню, ми маємо
                  запровадити відповідні фізичні, електронні та управлінські
                  засоби контролю для захисту інформації, яку ми збираємо
                  онлайн.
                </p>
                <h2 className="h2PrivacyPolicy">Як ми використовуємо файли cookie</h2>
                <p className="pPrivacyPolicy">
                  Файл cookie — це невеликий файл, який запитує дозвіл на розміщення
                  жорсткий диск комп'ютера. Коли ви погоджуєтеся, файл додається
                  і файл cookie допомагає аналізувати веб-трафік або повідомляє вам, коли
                  ви відвідуєте певний сайт. Файли cookie дозволяють веб-додаткам
                  відповідати вам як особистості. Веб-додаток може
                  пристосовувати свої операції до ваших потреб, симпатій і антипатій
                  збір і запам'ятовування інформації про ваші вподобання.
                </p>
                <p className="pPrivacyPolicy">
                  Ми використовуємо файли cookie журналу трафіку, щоб визначити, які сторінки відвідуються
                  використовується. Це допомагає нам аналізувати дані про трафік веб-сторінки та
                  покращити наш веб-сайт, щоб адаптувати його до потреб клієнтів.
                  Ми використовуємо цю інформацію лише для статистичного аналізу
                  а потім дані видаляються із системи.
                </p>
                <p className="pPrivacyPolicy">
                  Загалом, файли cookie допомагають нам надавати вам кращий веб-сайт
                  дозволяючи нам відстежувати, які сторінки ви вважаєте корисними, а які
                  ви не. Файли cookie жодним чином не дають нам доступу до ваших
                  комп’ютер або будь-яку інформацію про вас, крім даних, які ви
                  поділитися з нами.
                </p>
                <p className="pPrivacyPolicy">
                  Ви можете прийняти або відхилити файли cookie. Більшість веб-браузерів
                  автоматично приймати файли cookie, але зазвичай ви можете змінити свої
                  налаштування браузера для відхилення файлів cookie, якщо ви бажаєте. Це може
                  заважати вам повною мірою скористатися перевагами веб-сайту.
                </p>
                <h2 className="h2PrivacyPolicy">Посилання на інші веб-сайти</h2>
                <p className="pPrivacyPolicy">
                  Наш веб-сайт може містити посилання на інші цікаві веб-сайти.
                  Однак, якщо ви скористалися цими посиланнями, щоб залишити наш сайт, ви
                  слід зазначити, що ми не маємо жодного контролю над цим іншим
                  веб-сайт. Тому ми не можемо нести відповідальність за
                  захист і конфіденційність будь-якої інформації, яку ви надаєте
                  під час відвідування таких сайтів, і такі сайти не регулюються
                  цю заяву про конфіденційність. Ви повинні проявляти обережність і дивитися
                  у заяві про конфіденційність, що стосується веб-сайту в
                  запитання.
                </p>
                <h2 className="h2PrivacyPolicy">Конфіденційність дітей</h2>
                <p className="pPrivacyPolicy">
                  Наші Послуги не надаються дітям молодше віку, визначеного
                  правила країни походження (13 років або
                  більше в залежності від країни). Ми свідомо не збираємо
                  персональні дані дітей, які не досягли повноліття. в
                  якщо ми виявимо, що малолітня дитина надала нам
                  особисту інформацію, ми негайно видаляємо її з наших
                  серверів. Якщо ви є батьком або опікуном і знаєте
                  що ваша дитина надала нам особисту інформацію,
                  будь ласка, зв'яжіться з нами за адресою електронної пошти, вказаною в наступному розділі
                  щоб ми могли виконати необхідні дії для видалення
                  їхні персональні дані.
                </p>
                <h2 className="h2PrivacyPolicy">
                  Контроль вашої особистої інформації
                </h2>
                <p className="pPrivacyPolicy">
                  Ви можете запитати деталі особистої інформації, яку ми зберігаємо
                  про вас відповідно до Загального регламенту захисту даних в ЄС
                  або відповідного закону України. Невелика комісія може бути сплачена в
                  випадки явно необґрунтованих або надмірних запитів відповідно
                  вимогам GDPR та згідно укр
                  законодавства у разі доступу інших осіб до особистих
                  даних. Якщо ви бажаєте отримати копію інформації про вас
                  будь ласка, напишіть
                </p>
                <a href="mailto:info@sagax.software" className="aPrivacyPolicy">
                  info@sagax.software
                </a>
                <p className="pPrivacyPolicy">
                  Якщо ви вважаєте, що будь-яка інформація, яку ми маємо про вас, є
                  неправильні або неповні, будь ласка, напишіть нам або електронною поштою якнайшвидше
                  по можливості за вказаною вище адресою. Ми оперативно виправимо
                  будь-яка інформація, визнана невірною.
                </p>
                <p className="pPrivacyPolicy">
                  Ви можете обмежити збір або використання своїх
                  персональна інформація. Якщо ви хочете відкликати свою згоду
                  на ваші персональні дані, які ми обробляємо та зберігаємо, або
                  будь ласка, обмежте використання даних для цілей прямого маркетингу
                  зв’яжіться з нами за вказаною нижче адресою електронної пошти з відповідними
                  запит – ваші дані буде видалено зі сховища та
                  обробки протягом місяця.
                </p>
                <a href="mailto:info@sagax.software" className="aPrivacyPolicy">
                  info@sagax.software
                </a>
                <p className="pPrivacyPolicy">
                  Ми не будемо продавати, поширювати чи здавати в оренду вашу особисту інформацію
                  інформацію третім особам, якщо у нас немає вашого дозволу або
                  відповідно до закону. Ми можемо використовувати ваші особисті
                  інформація, щоб надіслати вам рекламну інформацію про третю
                  вечірки, які, на нашу думку, можуть здатися вам цікавими, якщо ви розкажете нам
                  що ви хочете, щоб це сталося.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};
export default PrivacyPolicyPage;
